const cleanFilterValues = (filterRef, newValues) => {
  // eslint-disable-next-line no-param-reassign
  filterRef.value = filterRef.value.filter((item) => newValues.indexOf(item) !== -1);
};

export default cleanFilterValues;
